<template>
    <div class="box1">
        <div class="additionalInformation" v-for="(item,index) in dataList" :key='index'>
            <div class="information">
                <div class="supervisionLevel">
                    <div class="title">督办级别</div>
                    <div class="details">{{item.typeLevelValue}}</div>
                </div>
                <div class="supervisor">
                    <div class="title">督办人</div>
                    <div class="details">
                        <span class="title_content" v-if="item.superviseUserPhone">{{item.superviseUserName|filt1}}-联系电话：{{item.superviseUserPhone}}</span>
                        <span class="phone"  @click="item.superviseUserPhone?showPhone(item.superviseUserPhone):''"> {{item.superviseUserName|filt2}}</span>
                    </div>
                </div>
                <div class="supervisionTime">
                    <div class="title">督办时间</div>
                    <div class="details">{{item.createTime}} &nbsp;&nbsp;&nbsp;&nbsp;</div>
                </div>
                <div class="supplementContent">
                    <div class="title">督办内容</div>
                    <div class="details">{{item.superviseContent}}</div>
                </div>
                <div class="save_content line_top" v-if="item.select">
                    <div v-for="(item1,index1) in item.saveList" :key="index1">
                        <span>回复机构</span>
                        <span>{{item1.replySuperviseOrgName}}</span>
                        <p>
                            <span>回复内容</span>
                            <span v-if="item1.replyContent">{{item1.replyContent}}</span>
                            <span v-else class="p_text">{{'待回复'}}</span>
                        </p>
                    </div>
                </div>
                <div class="save_content1 line_top">
                      <span v-if="!item.select" @click="showBox1(item,index)">展开督办信息回复</span>
                      <span v-if="item.select" @click="hideBox1(item,index)">收起督办回复</span>
                      <img src="../../../../assets/image/jiantou.png" :class="{'img_active':item.select}"/>
                </div>
            </div>
        </div>
        <isNoInfo :isNolist='isNolist'></isNoInfo>
        <call-phone ref="callPhone" :combinPhone="combinPhone"></call-phone>

    </div>
</template>
<script>
    import api from '../../../../service/modules/complaintApis';
    import isNoInfo from '../../../../components/isNoInfo';
    import scrollBottom from './scrollBottom';
    import callPhone from '../../../../components/callPhone';
    import util from '../../../../utils/common';
    export default {
        components: {
            isNoInfo,
            callPhone,
            'scroll-bottom': scrollBottom
        },
        data () {
            return {
                showSave: true,
                item: util.getJsonLocal('item'), 
                curPage: 1,
                pageSize: 10,
                dataList: [],
                isNolist: false,
                combinPhone: 0,
                phone: ''
            }
        },
        created () {
            this.handList();
        },
        methods: {
            showBox1 (item, index) {
                this.showSave = false;
                if (this.dataList.length === 1) {
                    this.$set(this.dataList[index], 'select', true)
                } else {
                    this.dataList.map((item, index) => {
                        this.$set(item, 'select', false);
                    })
                    this.$set(this.dataList[index], 'select', true);
                }

                this.getSaveList(item, index);
            },
            hideBox1 (item, index) {
                // this.showSave = true;
                this.$set(this.dataList[index], 'select', false)
            },
            handList () {
                let parms = {
                    data:{
                        mainComplainNumber: this.item.mainComplainNumber,
                        type: 'superviseDetails',
                        curPage: this.curPage,
                        pageSize: this.pageSize
                    }
                    
                };
                api.worker.detailInfo(parms).then(res => {
                    if (res.ret === 0) {
                        if (res.data) {
                            if (res.data.superviseDetails) {
                                if (res.data.superviseDetails.length > 0) {
                                    res.data.superviseDetails.map((item, index) => {
                                        this.$set(item, 'select', false);
                                        this.$set(item, 'saveList', '');
                                    })
                                    this.dataList = res.data.superviseDetails;
                                } else {
                                    this.isNolist = true
                                }
                            } else {
                                this.isNolist = true
                            }
                        } else {
                            this.isNolist = true
                        }
                        console.log(6666, res.data)
                    }
                });
            },
            getSaveList (item, index) {
                let params = {
                    data:{
                         mainComplainNumber: item.mainComplainNumber,
                         type: 'superviseReplyDetails',
                         superviseNumber: item.superviseNumber
                    }
                   
                }
                api.worker.detailInfo(params).then(res => {
                    if (res.ret === 0) {
                        // const arr = [];
                        // arr.push(res.data.replyContent);
                        this.$set(this.dataList[index], 'saveList', res.data.replyContent);
                        console.log('121212111111111111111111111');
                        console.log(this.dataList);
                    }
                })
            },
            // 打电话
            showPhone (value) {
                // let reg = value.replace(/[^0-9]/ig, '')
                this.combinPhone = parseInt(reg);
                this.$refs.callPhone.showBox();
            }
        },
        filters: {
            filt1 (str) {
                // let name = str.replace(/\d+/g, '');
                return str;
            },
            filt2 (str) {
                // let phone = str.replace(/[^0-9]/ig, '');
                return str;
            }
        }
    }
</script>
<style lang="less" scoped>
.box1 {
    padding: 0 12px 12px 12px;
    background-color: #FBFBFB;
    box-sizing: border-box;
    min-height: 6.2rem;
    position: relative;
    left:0;
    top:0;
    z-index: 2;
    .additionalInformation {
        margin: 0 0 24px 0;
        width: 100%;
        background-color: #fff;
        box-shadow: 0px 5px 10px 5px rgba(0, 0, 0, 0.04);
        padding: 16px;
        padding-bottom: 0;
        .information {
            width: 100%;
            font-size: 14px;
            .supervisionLevel,.supervisor,.supervisedDepartment,.supervisionTime,.supplementContent {
                display: flex;
                .title {
                    width: 70px;
                    color: #999999;
                }
                .details {
                    color: #333333;
                    margin-left: 20px;
                    width: 300px;
                    word-break: break-all;
                    .title_content {
                        color: #666666;
                    }
                    .phone{
                        color: #36B374;
                    }
                    span {
                        float: left;
                    }
                    img {
                        display: inline-block;
                        width: 15px;
                        margin-top: -2px;
                        margin-left: 5px;
                    }
                }
            }
            .supervisor,.supervisedDepartment,.supervisionTime,.supplementContent {
                margin-top: 12px;
            }
            .supplementContent {
                position: relative;
                margin: 0 auto;
                margin-top: 12px;
                margin-bottom: 10px;
                .title {
                    position: absolute;
                    top: 50%;
                    height: 14px;
                    margin-top: -7px;
                    word-wrap: none;
                }
                .details {
                    margin-left: 77px;
                    line-height: 18px;
                }
            }
            .save_content{
                width:100%;
                // margin-top:10px;
                transition: auto 0.5s ease-in-out;
                overflow: hidden;
                padding-top: 16px;
                div {
                    margin-bottom: 16px;
                }
                span:nth-child(1){
                    color:#999999;
                    font-size:14px;
                }
                span:nth-child(2){
                    font-size:14px;
                    margin-left:20px;
                }
                p {
                    margin-top: 16px;
                    .p_text {
                        color:#999999;
                    }
                }
            }
            .save_active{
                max-height: auto!important;
            }
            .save_content1{
                width:100%;
                height:40px;
                text-align: center;
                // margin-top:10px;
                padding: 16px 0px;
                span{
                    display: inline-block;
                    font-size:14px;
                    color:#999;
                    vertical-align: middle;
                }
                img{
                    display: inline-block;
                    width:8px;
                    height:7px;
                    vertical-align: middle;
                    margin-left:6px;
                    transform: rotate(0deg);
                    transition: all 0.5s ease-in-out;
                }
                .img_active{
                    transform: rotate(180deg);
                }
            }
        }
        .content {
            width: 100%;
            font-size: 14px;
            color: #333333;
            font-weight: Regular;
            margin-top: 12px;

        }
    }
    /deep/.main {
        .box1{
            margin-top: 100px;
        }
    }
}
</style>
